import { render, staticRenderFns } from "./SliderDots.vue?vue&type=template&id=686e2b33&scoped=true&"
import script from "./SliderDots.vue?vue&type=script&lang=js&"
export * from "./SliderDots.vue?vue&type=script&lang=js&"
import style0 from "./SliderDots.vue?vue&type=style&index=0&id=686e2b33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e2b33",
  null
  
)

export default component.exports